
import React from 'react';
import { connect } from 'react-redux';
import Toolbar from "../../../components/toolbar/Toolbar";
import { actions } from '../vehicleGroup.actions';
import { routes } from '../../../constants';
import { Page } from "../../../components/page/Page";
import { VehicleGroupForm } from './VehicleGroupForm';



const mapStateToProps = state => {
  const record = state.crudVehicleGroupState.currentRecord;


  return {
    record
    , vehicleTypes: [
      { label: 'Selecione uma opção', value: null }
      , { value: "CAR", label: "Carro" },
      { value: "TRUCK", label: "Caminhão" }
    ]
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: event => {
      const target = event.target;
      const field = target.name;
      let value = target.value;
      dispatch(actions.removeErrors([{ field }]));
      dispatch(actions.setField(field, value));
    },
    saveHandler: event => {
      dispatch(actions.save());
    },
    removeHandler: event => {
      dispatch(actions.remove());
    },
    newHandler: event => {
      dispatch(actions.makeNew());
    },
    loadById: oid => dispatch(actions.loadById(oid))
  }
}

class VehicleGroupFormPageContainer extends React.Component {

  constructor(props) {
    super(props);
    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_VEHICLE_GROUP}/${oid}`);
    };
    actions.afterNew = () => {
      this.props.history.replace(`${routes.PATH_VEHICLE_GROUP}/novo`);
    };
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_VEHICLE_GROUP}`);
    };
  }

  componentDidMount() {
    const oid = this.props.match.params.id;

    if (oid && parseInt(oid)) {
      this.props.loadById(oid);
    } else {
      this.props.newHandler();
    }
  }
  searchHandler = () => {
    this.props.history.push(`${routes.PATH_VEHICLE_GROUP}`)
  }
  onChangeHandlerCalculateCubage = e => {
    this.props.changeHandler(e);

    const height = parseFloat(e.target.name === 'height' ? e.target.value ? e.target.value : 0 : this.props.record.height ? this.props.record.height : 0);
    const width = parseFloat(e.target.name === 'width' ? e.target.value ? e.target.value : 0 : this.props.record.width ? this.props.record.width : 0);
    const depth = parseFloat(e.target.name === 'length' ? e.target.value ? e.target.value : 0 : this.props.record.length ? this.props.record.length : 0);

    let m3cubage = (height * width * depth) / 1000000;
    this.props.setField("cubage", m3cubage.toFixed(4));
  }

  onChangeHandlerCalculateNetWeight = e => {
    this.props.changeHandler(e);

    const tareWeight = parseFloat(e.target.name === 'tareWeight' ? e.target.value ? e.target.value : 0 : this.props.record.tareWeight ? this.props.record.tareWeight : 0);
    const maxWeight = parseFloat(e.target.name === 'maxWeight' ? e.target.value ? e.target.value : 0 : this.props.record.maxWeight ? this.props.record.maxWeight : 0);

    let netWeight = tareWeight - maxWeight;
    this.props.setField("netWeight", netWeight);
  }

  render() {
    const content = (
      <VehicleGroupForm
        changeHandler={this.props.changeHandler}
        record={this.props.record}
        onChangeHandlerCalculateCubage={this.onChangeHandlerCalculateCubage}
        onChangeHandlerCalculateNetWeight={this.onChangeHandlerCalculateNetWeight}
        vehicleTypes={this.props.vehicleTypes}


      />
    );
    const title = `Grupo de Veículos ${this.props.record.oid || 'novo'}`
    const header = (
      <div>
        <h1>{title}</h1>
        <div>
          <Toolbar
            onSave={this.props.saveHandler} saveButtonStyle='highlighted'
            onRemove={this.props.removeHandler} removeButtonStyle='danger'
            onNew={this.props.newHandler}
            onSearch={this.searchHandler}>
          </Toolbar>
        </div>
      </div>
    );
    return (<Page header={header} content={content} />);
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleGroupFormPageContainer);